module.exports = __webpack_public_path__ + "img/1f694.367b6b4.svg";